import { AxiosPromise } from 'axios';
import request from '@/utils/request';

import { FifaPlatVo, PlatUrlVo } from './type';
/**
 * fifa平台列表
  GET /product/api/fifa/plat/list
  接口ID：256890839
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-256890839
 */
export const getPlatFormList = (): AxiosPromise<FifaPlatVo[]> => {
  return request({
    url: '/product/api/fifa/plat/list',
    method: 'get'
  });
};

/**
 * fifa球员平台列表
  GET /product/api/fifa/player/plat/list
  接口ID：257122858
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257122858
 */
export const getPlayerPlatFormList = (params?: { gameUrl: string }): AxiosPromise<PlatUrlVo[]> => {
  return request({
    url: '/product/api/fifa/player/plat/list',
    method: 'get',
    params
  });
};

/**
 * fifa金币平台列表
  GET /product/api/fifa/coins/plat/list
  接口ID：257122859
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257122859
 */
export const getCoinsPlatFormList = (params?: { gameUrl: string }): AxiosPromise<PlatUrlVo> => {
  return request({
    url: '/product/api/fifa/coins/plat/list',
    method: 'get',
    params
  });
};
